module.exports = __webpack_public_path__ + "img/16-1.3adbd420.png";